import { CarouselModal, MicrobesOutlineBg } from '@repo/ui';
import { GATE_1_SLIDE_IDS } from 'contexts/analytics/events/gates';
import useAgreement from 'hooks/agreements/useAgreement';
import { useState } from 'react';
import useImpersonate from 'services/auth/useImpersonate';
import { AgreementKey } from 'types/Agreement';
import styles from './ConditionsEducationalModal.module.css';
import { useConditionsEducationalModal } from './context';
import useGate1Tracking from './hooks/useGate1Tracking';
import FinalSlide from './slides/FinalSlide';
import { STATIC_SLIDES } from './slides/staticSlides';

const GATE_SLIDE_IDS = [
  ...STATIC_SLIDES.map(({ id }) => id),
  GATE_1_SLIDE_IDS.REMINDERS,
];

const STATIC_SLIDE_CONTENT = STATIC_SLIDES.map(({ slide }) => slide);

export default function ConditionsEducationalModal() {
  const { impersonateId } = useImpersonate();
  const { reviewOpen, reviewNonce, closeReview } =
    useConditionsEducationalModal();
  const [visible, setVisible] = useState(true);

  const agreement = useAgreement(AgreementKey.NON_DIAGNOSTIC);

  // The mandatory consent gate always wins; a manual re-open only applies once
  // the user has already accepted.
  const gateOpen = visible && !agreement;
  const isReview = reviewOpen && !gateOpen;

  const { trackSlideChange, trackCompleted } = useGate1Tracking(
    gateOpen,
    GATE_SLIDE_IDS,
  );

  // On re-open the user has already consented, so we drop the checkbox slide
  // and let them dismiss freely.
  const closable = isReview || !!impersonateId;

  function handleClose() {
    if (isReview) closeReview();
    else setVisible(false);
  }

  return (
    <CarouselModal
      key={isReview ? `review-${reviewNonce}` : 'gate'}
      visible={gateOpen || isReview}
      slides={
        isReview
          ? STATIC_SLIDE_CONTENT
          : [
              ...STATIC_SLIDE_CONTENT,
              <FinalSlide setVisible={setVisible} onAgreed={trackCompleted} />,
            ]
      }
      background={<MicrobesOutlineBg />}
      modalContentClassName={styles.modalContent}
      onClose={closable ? handleClose : undefined}
      onSlideChange={trackSlideChange}
      enableSwipe
    />
  );
}
